/**
 * Daigle - Couche de suivi des conversions
 * ----------------------------------------
 * Emet trois objectifs, independamment de l'outil d'analytique installe :
 *   1. generate_lead   soumission de formulaire REUSSIE (les deux tiroirs)
 *   2. click_to_call   clic sur un lien telephone
 *   3. click_to_email  clic sur un lien courriel
 *   4. click_contact_page  clic vers la page de contact
 *   5. click_book_visit    clic sur un CTA de prise de rendez-vous
 *   6. book_appointment    rendez-vous REELLEMENT confirme dans Calendly
 *
 * Chaque evenement est diffuse sur trois canaux, donc il remontera quel que
 * soit le mode d'installation choisi plus tard :
 *   - Shopify.analytics.publish()  -> pixels web Shopify (GA4 en pixel perso, Meta...)
 *   - window.dataLayer.push()      -> Google Tag Manager
 *   - window.gtag()                -> GA4 pose en direct (gtag.js)
 *
 * AUCUNE donnee personnelle n'est transmise : ni nom, ni courriel, ni telephone
 * du visiteur. C'est une exigence des conditions d'utilisation de GA4.
 */
(function () {
  'use strict';

  var PENDING_KEY = 'dgLeadPending';
  var lastClick = { el: null, at: 0 };

  /* ----------------------------------------------------------------------
   * Diffusion
   * -------------------------------------------------------------------- */

  // Les pixels web Shopify vivent dans une iframe isolee : ils ne voient pas
  // le dataLayer de la page. Shopify.analytics.publish est le pont officiel.
  function publishToPixels(name, params) {
    var tries = 0;
    (function attempt() {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') {
        try { a.publish(name, params); } catch (e) {}
        return;
      }
      if (tries++ < 20) setTimeout(attempt, 250);
    })();
  }

  function track(name, params) {
    params = params || {};
    params.event_source = 'daigle-theme';

    window.dataLayer = window.dataLayer || [];
    try {
      window.dataLayer.push(Object.assign({ event: name }, params));
    } catch (e) {}

    if (typeof window.gtag === 'function') {
      try { window.gtag('event', name, params); } catch (e) {}
    }

    publishToPixels(name, params);

    // Point d'accroche pour du debogage ou un futur outil tiers.
    try {
      document.dispatchEvent(new CustomEvent('dg:track', { detail: { name: name, params: params } }));
    } catch (e) {}

    if (window.dgTrackDebug) console.log('[dgTrack]', name, params);
  }

  window.dgTrack = track;

  /* ----------------------------------------------------------------------
   * Contexte
   * -------------------------------------------------------------------- */

  // Type de page, tolerant au prefixe de langue (/en/products/...).
  function pageType() {
    var p = window.location.pathname;
    if (/\/products\//.test(p)) return 'fiche_produit';
    if (/\/collections\//.test(p)) return 'collection';
    if (/\/blogs\//.test(p)) return 'blogue';
    if (/\/pages\//.test(p)) return 'page';
    if (/\/search/.test(p)) return 'recherche';
    if (p === '/' || /^\/[a-z]{2}(-[a-z]{2})?\/?$/i.test(p)) return 'accueil';
    return 'autre';
  }

  // Zone de la page, deduite de la section Daigle qui contient l'element.
  // Les sections portent une classe dg-section-<nom> (voir leur schema).
  function zone(el) {
    if (!el || !el.closest) return 'inconnue';
    if (el.classList && el.classList.contains('dg-floating-call')) return 'bouton-flottant';
    if (el.closest('.dg-qd')) return 'tiroir-soumission';
    var host = el.closest('[class*="dg-section-"]');
    if (host) {
      var m = String(host.className).match(/dg-section-([a-z0-9-]+)/);
      if (m) return m[1];
    }
    if (el.closest('footer')) return 'pied-de-page';
    if (el.closest('header')) return 'entete';
    return 'contenu';
  }

  function label(el) {
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t) t = el.getAttribute('aria-label') || '';
    return t.slice(0, 100);
  }

  // Reconnait un lien vers la page de contact, y compris en URL absolue vers
  // la meme boutique et avec le prefixe de langue du site anglais
  // (/en/pages/contact). Les ancres et parametres sont ignores ici, ils sont
  // lus separement pour qualifier l'intention.
  function contactTarget(href) {
    if (!href || href.charAt(0) === '#') return null;
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return null; }
    if (u.origin !== window.location.origin) return null;
    if (!/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/contact\/?$/i.test(u.pathname)) return null;
    return u;
  }

  // La page de contact sert trois intentions distinctes selon l'ancre.
  function contactIntent(u) {
    var h = (u.hash || '').replace('#', '').toLowerCase();
    if (h === 'rachat') return 'rachat-machine';
    if (h === 'local') return 'localisation';
    if (h) return h;
    return 'formulaire';
  }

  /* ----------------------------------------------------------------------
   * 1. generate_lead : soumission REUSSIE
   *
   * Les deux tiroirs utilisent le formulaire de contact natif Shopify : la
   * page se recharge avec ?contact_posted=true en cas de succes. On memorise
   * donc le contexte a l'envoi, et on emet l'evenement au rechargement.
   * Compter au clic sur « Envoyer » gonflerait le chiffre avec les envois
   * qui echouent la validation.
   * -------------------------------------------------------------------- */

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.id) return;
    var isProduct = f.id === 'dg-quote-form';
    var isGeneral = f.id === 'dg-quote-form-gen';
    if (!isProduct && !isGeneral) return;

    var val = function (n) {
      var el = f.querySelector('[name="' + n + '"]');
      return el ? el.value : '';
    };
    var optin = f.querySelector('[name="contact[Infolettre machinerie]"]');

    var payload = {
      form_id: f.id,
      form_location: isProduct ? 'fiche-produit' : 'general',
      request_type: val('contact[Type de demande]'),
      product_title: val('contact[Produit]'),
      product_sku: val('contact[SKU]'),
      page_path: window.location.pathname,
      page_type: pageType(),
      // Presence seulement, jamais la valeur : pas de donnee personnelle.
      has_phone: val('contact[phone]') ? 'oui' : 'non',
      newsletter_optin: optin && optin.checked ? 'oui' : 'non'
    };

    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(payload)); } catch (err) {}
  }, true);

  function flushLead() {
    if (!/[?&]contact_posted=true/.test(window.location.search)) return;

    var raw = null;
    try { raw = sessionStorage.getItem(PENDING_KEY); } catch (e) {}
    if (!raw) return; // rechargement manuel de l'URL : on ne compte pas deux fois

    try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}

    var payload;
    try { payload = JSON.parse(raw); } catch (e) { payload = {}; }
    track('generate_lead', payload);
  }

  /* ----------------------------------------------------------------------
   * 2, 3 et 4. Clics telephone, courriel et page de contact
   * -------------------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;

    var href = a.getAttribute('href') || '';
    var isPhone = href.indexOf('tel:') === 0;
    var isMail = href.indexOf('mailto:') === 0;
    var contact = (isPhone || isMail) ? null : contactTarget(href);
    if (!isPhone && !isMail && !contact) return;

    var now = Date.now();
    // Anti double-comptage sur le MEME element. On compare l'element et non
    // l'URL : l'entete, le pied de page et le bouton flottant partagent le
    // meme numero, et chacun de ces trois clics doit etre compte.
    if (a === lastClick.el && now - lastClick.at < 1000) return;
    lastClick = { el: a, at: now };

    var common = {
      link_url: href,
      link_text: label(a),
      link_location: zone(a),
      page_path: window.location.pathname,
      page_type: pageType()
    };

    if (contact) {
      common.contact_intent = contactIntent(contact);
      // Certains CTA de fiche produit pointent vers /pages/contact?product=<handle>
      var handle = contact.searchParams ? contact.searchParams.get('product') : null;
      if (handle) common.product_handle = handle;

      // Plusieurs CTA pointent vers /pages/contact mais sont interceptes par le
      // tiroir de soumission, qui fait preventDefault et ouvre le tiroir au lieu
      // de naviguer. On sort du cycle de l'evenement pour ne compter que les
      // clics qui menent reellement a la page de contact.
      setTimeout(function () {
        if (e.defaultPrevented) return;
        track('click_contact_page', common);
      }, 0);
      return;
    }

    common.method = isPhone ? 'telephone' : 'courriel';
    track(isPhone ? 'click_to_call' : 'click_to_email', common);
  }, true);

  /* ----------------------------------------------------------------------
   * 5. click_book_visit : clic sur un CTA de prise de rendez-vous
   * (page Planifier une visite, en FR comme en EN, ou lien Calendly direct)
   * -------------------------------------------------------------------- */

  function bookingTarget(href) {
    if (!href) return null;
    if (href.indexOf('calendly.com') !== -1) return 'calendly';
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return null; }
    if (u.origin !== window.location.origin) return null;
    if (/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/(planifier-visite|schedule-a-visit)\/?$/i.test(u.pathname)) return 'page';
    return null;
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var kind = bookingTarget(a.getAttribute('href'));
    if (!kind) return;
    track('click_book_visit', {
      link_url: a.getAttribute('href'),
      link_text: label(a),
      link_location: zone(a),
      page_path: window.location.pathname,
      page_type: pageType(),
      method: kind === 'calendly' ? 'calendly_direct' : 'page_rendez_vous'
    });
  }, true);

  /* ----------------------------------------------------------------------
   * 6. book_appointment : Calendly confirme un rendez-vous
   * Le widget publie ses etapes par postMessage ; seul event_scheduled
   * correspond a un rendez-vous reellement pris.
   * -------------------------------------------------------------------- */

  window.addEventListener('message', function (e) {
    if (!e.data || typeof e.data.event !== 'string') return;
    if (e.data.event.indexOf('calendly.') !== 0) return;
    if (e.data.event !== 'calendly.event_scheduled') return;
    track('book_appointment', {
      method: 'calendly',
      page_path: window.location.pathname,
      page_type: pageType()
    });
  });

  /* -------------------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', flushLead);
  } else {
    flushLead();
  }
})();
